import { Labels } from '../global/labels';
import type { TranslationLabels } from '../types/labels.type';

/**
 * Abstract template class for UI components. It provides a structure for rendering
 * components and handling translations.
 * @abstract
 * @memberof SharedComponents
 * @alias UITemplate
 */
export abstract class UITemplate {
    protected _data: unknown;

    constructor(data: unknown) {
        this._data = data;
    }

    /**
     * @type {Labels}
     * @readonly
     */
    static get labels(): TranslationLabels.Labels {
        return {};
    }

    /**
     * @param {string} key
     * @param {number|Array<string>|Record<string, string>} [substitutions]
     * @returns {string}
     */
    getLabel(
        key: string,
        substitutions: TranslationLabels.Substitutions
    ): TranslationLabels.Label {
        return Labels.processLabel(
            (this.constructor as typeof UITemplate).labels,
            key,
            substitutions
        );
    }

    /**
     * @param {Array<unknown>} args
     * @returns {DocumentFragment}
     */
    static render(...args: Array<unknown>): DocumentFragment {
        const Constructor = this as unknown as new (
            ...args: Array<unknown>
        ) => UITemplate;
        return new Constructor(...args).render();
    }

    /**
     * @returns {DocumentFragment}
     */
    abstract render(): DocumentFragment;
}
